<template>
  <v-dialog
    v-model="dialog"
    max-width="400px"
    overlay-opacity="0.95"
    persistent
    content-class="rounded-xl"
    style="overflow: hidden"
  >
    <v-card
      v-if="!!ticket"
      style="overflow: hidden"
      rounded="xl"
      v-touch="{
        right: swipe('right'),
        left: swipe('left'),
      }"
    >
      <v-card-title class="headline">
        <div class="w-full text-center">
          <p
            class="text-overline font-weight-bold mb-0 text--secondary text-truncate"
            style="line-height: 1em"
          >
            {{ ticket?.TicketBlock?.TicketGroup?.Party?.name }}
          </p>
          <p class="text-body-1 font-weight-black text-truncate mb-0">
            {{ ticket?.TicketBlock?.TicketGroup?.name }}
            •
            {{ ticket?.TicketBlock?.name }}
          </p>
          <p
            v-if="ticket.Table"
            class="text-overline font-weight-bold mb-0 text--secondary text-truncate mt-1"
            style="line-height: 1em"
          >
            {{ ticket?.Table?.Group?.name }}
            •
            {{ ticket?.Table?.name }}
          </p>
        </div>
      </v-card-title>
      <v-card-text class="px-0 pb-2">
        <div class="d-flex justify-center align-center">
          <div class="rounded" style="position: relative">
            <qrcode-vue
              style="
                background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=);
                background-size: cover;
              "
              class="d-flex justify-center pa-5 ma-1 white rounded"
              :value="qrCodeLink"
              size="260"
              level="M"
            />
            <div
              style="position: absolute; top: 0px; height: 100%; width: 100%"
              class="d-flex justify-center align-center"
            >
              <div v-if="tempTicketUsedDisabled" class="white rounded-lg pa-1">
                <v-chip label small color="warning"> Usado </v-chip>
              </div>
              <div
                v-else
                style="width: 36px; height: 36px; align-content: center"
                class="white rounded"
              >
                <v-img src="/favicon.png" contain height="36" />
              </div>
            </div>

            <v-fade-transition>
              <v-overlay
                v-if="ticketUsed && !tempTicketUsedDisabled"
                absolute
                opacity="0.9"
                color="black"
              >
                <v-btn
                  icon
                  @click="tempTicketUsedDisabled = true"
                  style="position: absolute; top: -60px; right: -30px"
                >
                  <v-icon style="opacity: 0.6" size="18">mdi-eye</v-icon>
                </v-btn>
                <div class="d-flex flex-column justify-center align-center">
                  <v-icon class="white--text" size="100">mdi-ticket</v-icon>
                  <h3 class="white--text text-h5 font-weight-black text-center">
                    Ingresso já utilizado
                  </h3>
                  <small>
                    em
                    {{
                      ticket.TicketEntry[0].createdAt | date("DD/MM/YY HH:mm")
                    }}
                  </small>
                </div>
              </v-overlay>
            </v-fade-transition>
          </div>
        </div>
        <div
          v-if="ticket?.TicketBlock?.useRequirement"
          class="d-flex justify-center align-center"
          style="margin-top: -8px"
        >
          <small class="text-12 text--secondary text-center lh-1">
            Requisito para uso:<br />
            {{ ticket?.TicketBlock?.useRequirement }}
          </small>
        </div>

        <div class="d-flex justify-space-around mx-8 lh-1 text-center py-2">
          <small>
            Ingresso<br />
            <b class="text-overline lh-1"> #{{ ticket.id | shortId }} </b>
          </small>
          <small>
            Pagamento<br />
            <b class="text-overline lh-1">
              #{{ ticket?.Payment?.id | shortId }}
            </b>
          </small>
        </div>

        <div
          v-if="!!tickets && tickets.length > 1"
          class="d-flex justify-center align-center gap-6"
        >
          <v-btn @click="swipe('right')()" icon>
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <span class="font-weight-black">
            {{ currentIndex + 1 }}/{{ tickets.length }}
          </span>
          <v-btn @click="swipe('left')()" icon>
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </div>

        <v-alert
          v-if="ticket?.TicketBlock?.concessionTicket"
          dense
          text
          color="warning"
          class="mb-0 mt-2 mx-6"
        >
          Ingresso válido mediante apresentação de comprovante de direito a meia
          entrada
        </v-alert>

        <v-alert
          v-if="user"
          color="info"
          class="mb-0 mt-2 mx-6"
          text
          dense
          border="bottom"
        >
          O ingresso pertence a
          <span class="font-weight-bold">{{ user?.name }}</span> com CPF
          <span class="font-weight-bold">{{ obfuscatedCPF }}</span>
        </v-alert>
        <v-alert
          v-else
          color="info"
          class="mb-0 mt-2 mx-6"
          text
          dense
          border="bottom"
        >
          O ingresso está vinculado ao número de telefone
          <span class="font-weight-bold">{{ ticket?.ownerPhone }}</span>
        </v-alert>
      </v-card-text>
      <v-card-actions class="flex-column pt-0">
       
        <v-btn color="primary" text @click="close" block>Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import QrcodeVue from "qrcode.vue";
import { mapGetters } from "vuex";
export default {
  components: { QrcodeVue },
  data: () => ({
    dialog: false,
    tempTicketUsedDisabled: false,
  }),
  methods: {
    open() {
      this.dialog = true;
      this.tempTicketUsedDisabled = false;
    },
    close() {
      this.dialog = false;
    },
    swipe(direction) {
      if (!this.tickets.length) return null;
      return () => {
        this.vibrate(50);
        if (direction === "right") this.$emit("prev");
        else this.$emit("next");
      };
    },
    vibrate(val) {
      if (navigator.vibrate) navigator.vibrate(val);
    },
    verifyIsUUID(str) {
      const uuidRegex =
        /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
      return uuidRegex.test(str);
    },
  },
  computed: {
    ...mapGetters("auth", ["user"]),
    ticketUsed() {
      if (!this.ticket) return false;
      const periodsLength = this.party?.Period?.length || 1;
      return (
        this.ticket.TicketEntry &&
        this.ticket.TicketEntry.length >= periodsLength
      );
    },
    obfuscatedCPF() {
      if (!this.user?.document) return "";
      return this.user.document
        .replace(/\D/g, "")
        .replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.***.***-$4");
    },
    qrCodeLink() {
      const isUUID = this.verifyIsUUID(this.ticket.code);
      if (!isUUID) return this.ticket.code;
      return `${window.location.origin}/verify/ticket/${this.ticket.code}?f=D`;
    },
  },
  watch: {
    ticket() {
      this.tempTicketUsedDisabled = false;
    },
  },
  props: {
    party: {
      type: Object,
      default: () => null,
    },
    ticket: {
      type: Object,
      default: () => null,
    },
    tickets: {
      type: Array,
      default: () => [],
    },
    currentIndex: {
      type: Number,
      default: 0,
    },
  },

  mounted() {
    this.$parent.$on("openQrCode", this.open);
  },
};
</script>

<style></style>
